import axios from "axios"; //axios引入
//引入封装的吐司，进度条等
import { Message } from "element-ui";
import { setToken, getToken, getrefeshToken,setrefreshToken,removerefreshToken } from "utils/storage";
import { showLoading, hideLoading } from "./load";
import router from "@/router";
import Cookies from 'js-cookie'
import {authrefreshToken} from '@/api/login'
axios.defaults.withCredentials = false; //让ajax携带cookie
if (!Cookies.get('udid')) {
    var len = 16;
    var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    var maxPos = $chars.length;
    var pwd = '';
    for (var i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    Cookies.set('udid', pwd, { expires:  365})
}
// const isPro = Object.is(process.env.NODE_ENV, 'production')
/* var lb = null; //进度条默认不显示
var vuer = null; //vue 对象，传递过来的 */
var msg = ""; //传过来的msg
// 创建axios实例
const service = axios.create({
  //以下为代理跨域的一些baseURL，因为我们有不同的域名，暂时不用
  // baseURL: process.env.BASE_API, // api的base_url
    timeout: 15000, // 请求超时时间,
});

// request请求拦截器
service.interceptors.request.use(
  config => {
        var timestamp = new Date().getTime();
        config.headers["timestamp"] = timestamp;
        if (getToken()) {
          config.headers["Authorization"] = "Bearer " + getToken();
        }
        config.headers["udid"] = Cookies.get('udid');
        config.headers["lang"] = localStorage.getItem('language')=='en_ID'? 'en_ID':'en_US'
        config.headers["client-platform"] = 1
        config.headers["app-name"] = 'meetnovel'
        if (config.hds == 1) {
          //上传图片
          config.headers["Content-Type"] = "multipart/form-data";
        } else if (config.hds == 2) {
          //json格式
          config.headers["Content-Type"] = "application/json;charset=UTF-8";
        } else {
          //键值对
          config.headers["Content-Type"] = "application/x-www-form-urlencoded";
        }

        //请求的时候加入进度条（在这里可以传入进入条的图标、msg（封装时已默认加载中），还可以传入特定的值约束，比如：msg ==0 时，不展示）
        msg = config.msg;
        return config;
  },
  error => {
    //网络不通，跳转404页面
    console.log("request跳转404页面：" + error); // 跳转404页面
    Promise.reject(error);
  }
);

// respone返回拦截器
service.interceptors.response.use(
  response => {
    hideLoading();
    if (response.headers.access_token) {
      setToken(response.headers.access_token);
    }
   if (response.headers.refresh_token) {
      setrefreshToken(response.headers.refresh_token);
   }
    //请求成功后隐藏进度条
    if (msg != 0) {
    }
    const res = response.data;
    if (res !== null) {
      if (res.success || res.code == "newMonthly") {
      } else {
          if (res.redirect) {
              Message({
                  showClose: true,
                  message: res.message,
                  type: "error",
                  duration: 1500
              });
              setToken(null)
              removerefreshToken()
              // localStorage.clear();
              router.push({
                name: "home",
                query: { redirect: router.currentRoute.fullPath }
              });
              // router.push('/')
          } else if (res.code == 20066){
              authrefreshToken({refreshToken: getrefeshToken()}).then(res=>{
                  if (res.success) {
                      router.go(0)
                  }
              })
          } else{
              Message({
                  showClose: true,
                  message: res.message,
                  type: "error",
                  duration: 1500
              });
          }
      }
      //成功后的成功返回
      return Promise.resolve(res);
    } else {
      console.log("err:", response.data);
      // 成功后的失败返回
      return Promise.reject(res);
    }
  },
  error => {
    hideLoading();
    //这里只是全局处理不用返回
    if (msg != 0) {
    }
    if (
      error.code === "ECONNABORTED" &&
      error.message.indexOf("timeout") !== -1
    ) {
      //console.log('根据你设置的timeout/真的请求超时 判断请求现在超时了，你可以在这里加入超时的处理方案')
      var originalRequest = error.config;
      return service.request(originalRequest); //例如再重复请求一次
    } else {
        Message({
            message: error,
            type: "error"
        });
    }
  }
);

export default service;
